/* ============================================================
   RECENTLY VIEWED, RECORDED BY THE PAGE ITSELF

   Horizon recorded a product view with an inline module in <head>:

     import { RecentlyViewed } from '@theme/recently-viewed-products';
     RecentlyViewed.addProduct('{{ product.id }}');

   That runs once per DOCUMENT — and with no-reload navigation
   (custom.pageswap.js) there is one document per visit, so every product
   reached by a swap went unrecorded and the predictive-search "recently
   viewed" list froze on whatever page the visit started on.

   The fix is the shape of the fix for everything of this class: stop doing
   per-template work in the head. The product id now rides in the markup as
   <ffg-recently-viewed data-product-id="…"> (emitted by
   sections/custom-product-story.liquid, inside #MainContent), and this file
   — loaded on EVERY page by custom.globals.liquid — defines the element.
   Custom elements upgrade whenever their markup enters the document, however
   it got there: a hard load, a swap's innerHTML, anything. No swap
   compensation, no inline module to replay, nothing to forget.

   connectedCallback fires again if the same node is re-attached (Back to a
   cached swap, an editor re-render). Harmless: addProduct de-dupes by id and
   moves the product to the front of the list, which is what "viewed again"
   should do anyway.
   ============================================================ */
import { RecentlyViewed } from '@theme/recently-viewed-products';

class FFGRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const id = this.getAttribute('data-product-id');
    if (id) RecentlyViewed.addProduct(id);
  }
}

if (!customElements.get('ffg-recently-viewed')) {
  customElements.define('ffg-recently-viewed', FFGRecentlyViewed);
}
